/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    disabled: PropTypes.bool,
    status: PropTypes.oneOf([
        'error',
        'valid',
        'standard',
    ]).isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    disabled: false,
    status: 'standard',
};

const FormItem = (props) => {
    const classNames = [
        'c-form-item',
        props.disabled ? 'c-form-item--disabled' : '',
        props.status === 'error' ? 'c-form-item--error' : '',
        props.status === 'valid' ? 'c-form-item--valid' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

FormItem.propTypes = propTypes;

FormItem.defaultProps = defaultProps;

export default FormItem;
